/**
 * MarketingHeader — the ONE sticky header shared by every public page (Landing, Pricing, Discover…).
 *
 * Guarantees the same nav + language switcher everywhere the visitor goes (so language can be changed
 * on any page). Nav links use ABSOLUTE paths (/#what, /#how) so they work from /pricing and /discover
 * too — clicking jumps to the homepage section. Labels come from the land.* i18n namespace.
 */
import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Logo from '../assets/brand/cometqr-icon-navy.png';
import LangMenu from './LangMenu';
import './marketing-nav.css';

const MarketingHeader = () => {
    const { t } = useTranslation();
    return (
        <header className='mkt-nav'>
            <div className='mkt-nav-in'>
                <a className='mkt-brand' href='/'>
                    <img src={Logo} alt='CometQR' />
                    <span>CometQR</span>
                </a>
                <nav className='mkt-nav-right'>
                    <a href='/#what' className='mkt-link'>{t('land.nav_what')}</a>
                    <a href='/#how' className='mkt-link'>{t('land.nav_how')}</a>
                    <Link to='/discover' className='mkt-link'>{t('land.nav_discover')}</Link>
                    <Link to='/pricing' className='mkt-link'>{t('land.nav_pricing')}</Link>
                    <LangMenu />
                    <a href='/login' className='mkt-login'>{t('land.nav_login')}</a>
                    <Link to='/register' className='mkt-cta'>{t('land.nav_start')}</Link>
                </nav>
            </div>
        </header>
    );
};

export default MarketingHeader;
